<template>
    <b-form-row>
        <b-modal size="md" button-size="sm" hide-footer v-model="showModal" :title="prefix + title" @hidden="cancelar">
            <b-form @submit.prevent="save">
                <b-card bg-variant="light">
                    <b-form-row>
                        <lg-form-input invalidFeedback="Informe uma descrição válida!" description=" "
                            :error="$v.form.descricao" v-model="form.descricao" label="Descrição:*" cols="12" />
                    </b-form-row>

                    <b-form-row>
                        <lg-form-input invalidFeedback="Informe a Data Inicial!" description=" "
                            :error="$v.form.dataInicial" v-model="form.dataInicial" label="Data Inicial:*" cols="6"
                            type="date" />
                        <lg-form-input invalidFeedback="Informe a Data Final!" description=" "
                            :error="$v.form.dataFinal" v-model="form.dataFinal" label="Data Final:*" cols="6"
                            type="date" />
                    </b-form-row>

                    <b-form-row>
                        <b-form-group label="Status:*" class="ml-3">
                            <b-form-radio-group v-model="form.situacao" :options="statusOptions" size="sm"
                                name="status-inline"></b-form-radio-group>
                        </b-form-group>
                    </b-form-row>

                    <b-form-row>
                        <lg-form-const-select label="Tipo Exercício Fiscal:*" sm="4" md="4"
                            v-model="form.tipoExercicioFiscalId" :options="tipoOptions" />
                    </b-form-row>

                    <b-form-row>
                        <b-col cols="3"></b-col>
                        <b-col cols="6" class="text-center">
                            <b-button id="salvarExercicioFiscalForm" class="my-2" size="sm" pill variant="success"
                                @click="save">
                                <b-icon icon="check-circle" />
                                <b-tooltip target="salvarExercicioFiscalForm" title="Salvar"></b-tooltip>
                            </b-button>
                            <b-button id="cancelarExercicioFiscalForm" class="my-2 ml-2" size="sm" pill variant="danger"
                                @click="cancelar">
                                <b-icon icon="x-circle" />
                                <b-tooltip target="cancelarExercicioFiscalForm" title="Cancelar"></b-tooltip>
                            </b-button>
                        </b-col>
                        <b-col cols="3"></b-col>
                    </b-form-row>
                </b-card>
            </b-form>
        </b-modal>
    </b-form-row>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import ResourceService from "@/core/api/ResourceService";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue";
import moment from "moment";
import { FormResourceMixin } from "@/core/mixins/resource";

export default {
    components: {
        LgFormInput,
        LgFormConstSelect,
    },
    mixins: [FormResourceMixin],
    props: {
        id: Number,
        prefix: {
            type: String,
            default: "",
        },
    },
    validations: {
        form: {
            descricao: { required },
            dataInicial: { required },
            dataFinal: { required },
            situacao: { required },
            tipoExercicioFiscalId: { required },
        },
    },
    data() {
        return {
            statusOptions: [
                { text: "Ativo", value: 1 },
                { text: "Inativo", value: 0 },
            ],
            tipoOptions: [
                { key: "", text: "" },
                { key: "tipoExercicio", text: "Média", value: 2 }
            ],
            showModal: true,
            title: "Cadastro de Exercício Fiscal",
            form: {
                descricao: "",
                dataInicial: "",
                dataFinal: "",
                situacao: 1,
                tipoExercicioFiscalId: null,
                statusId: 1
            },
        };
    },
    beforeMount() {
        this.$service = new ResourceService("/api/exercicio-fiscal");
    },
    async mounted() {
        if (this.id) {
            try {
                const { data } = await this.$service.getById(this.id);
                this.form = {
                    ...data,
                    dataInicial: moment(data.dataInicial).format("YYYY-MM-DD"),
                    dataFinal: moment(data.dataFinal).format("YYYY-MM-DD"),
                };
            } catch (error) {
                console.error("Erro ao carregar os dados:", error);
            }
        }
    },
    methods: {
        async save() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                this.$notify({
                    type: "danger",
                    message: "Verifique os campos de cadastro.",
                });
                return;
            }
            const payload = { ...this.form };
            payload.dataInicial = moment(payload.dataInicial, "YYYY-MM-DD").format("YYYY-MM-DD[T]HH:mm:ss");
            payload.dataFinal = moment(payload.dataFinal, "YYYY-MM-DD").format("YYYY-MM-DD[T]HH:mm:ss");
            await this.$saveResource(payload, "", true, {}, false, true);
            this.cancelar();
        },
        cancelar() {
            this.$emit("close");
        },
    },
};
</script>
